/* eslint-disable no-trailing-spaces */
/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable @typescript-eslint/no-inferrable-types */
/* eslint-disable @typescript-eslint/naming-convention */

import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthenticationService } from './authentication.service';
import { BehaviorSubject, Observable, from } from 'rxjs';
import { environment } from 'src/environments/environment';
import { TurnoNoInformado, Turnos } from '../models/turnos';
import { HttpResponseAPI } from '../models/httpResponse';
import { concatMap } from 'rxjs/operators';
import * as moment from 'moment';
import { ToastController } from '@ionic/angular';

@Injectable({ providedIn: 'root' })
export class TurnosService {

    // #region Propiedades públicas
    loading$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    private turnoActivo: Turnos;
    ta$: BehaviorSubject<Turnos> = new BehaviorSubject<Turnos>(null);
    turnoActivo$: Observable<Turnos> = this.ta$.asObservable();

    private turnos: Turnos[] = [];
    t$: BehaviorSubject<Turnos[]> = new BehaviorSubject<Turnos[]>(this.turnos);
    turnos$: Observable<Turnos[]> = this.t$.asObservable();

    private turnosCaducados: Turnos[] = [];
    tc$: BehaviorSubject<Turnos[]> = new BehaviorSubject<Turnos[]>(this.turnosCaducados);
    turnosCaducados$: Observable<Turnos[]> = this.tc$.asObservable();
    // #endregion

    private nombreServicio: string = 'turnos';

    constructor(
        private httpClient: HttpClient,
        private authenticationService: AuthenticationService,
        public toastController: ToastController
    ) { }

    // #region Métodos del servicio relacionados directamente con la API

    /**
     * Obtiene la lista de turnos por empleado.
     */
    getTurnosPorEmpleado(): void {
        this.loading$.next(true);
        const cargarToken = from(this.authenticationService.loadToken());

        cargarToken
            .pipe(
                concatMap(() => {
                    const headers = new HttpHeaders({
                        'Content-Type': 'application/json',
                        Authorization: 'Bearer ' + this.authenticationService.token
                    });

                    return this.httpClient.get<HttpResponseAPI>(`${environment.apiUrl}/${this.nombreServicio}/byEmployee`, { headers });
                })
            )
            .subscribe({
                next: (resultado: HttpResponseAPI) => {
                    this.turnos = resultado.data;
                    this.t$.next(this.turnos);

                    // Comprueba si hay un turno activo
                    this.turnoActivo = this.turnos.find(turno => turno.activo);

                    if (this.turnoActivo != null) {
                        this.ta$.next(this.turnoActivo);
                    }

                    // Obtiene los turnos caducados
                    this.turnosCaducados = this.turnos.filter(turno => turno.fin < new Date());
                    this.tc$.next(this.turnosCaducados);
                },
                complete: () => {
                    this.loading$.next(false);
                }
            });
    }

    /**
     * Crea un nuevo turno no informado.
     * @param turnoNoInformado El turno no informado a crear.
     * @returns Un Observable que emite el resultado de la operación.
     */
    turnoNoInformado(turnoNoInformado: TurnoNoInformado): Observable<HttpResponseAPI> {
        this.loading$.next(true);
        const cargarToken = from(this.authenticationService.loadToken());

        return new Observable((observer) => {
            cargarToken
                .pipe(
                    concatMap(() => {
                        const headers = new HttpHeaders({
                            'Content-Type': 'application/json',
                            Authorization: 'Bearer ' + this.authenticationService.token
                        });
    
                        return this.httpClient.post<HttpResponseAPI>(`${environment.apiUrl}/${this.nombreServicio}/turnoNoInformado`, turnoNoInformado, { headers });
                    })
                )
                .subscribe({
                    next: (resultado: HttpResponseAPI) => {
                        let turnoEnviado: boolean = resultado.data as boolean;

                        if (turnoEnviado) {
                            // Mostrar mensaje de confirmación
                            this.toastController.create({
                                message: 'Turno no informado correctamente',
                                duration: 2000,
                                position: 'bottom',
                                color: 'success'
                            }).then((toast) => {
                                toast.present();
                            });
                        } else {
                            // Mostrar mensaje de error
                            this.toastController.create({
                                message: 'Error al informar del turno',
                                duration: 2000,
                                position: 'bottom',
                                color: 'danger'
                            }).then((toast) => {
                                toast.present();
                            });
                        }

                        observer.next(resultado);
                        observer.complete();
                    },
                    complete: () => {
                        this.loading$.next(false);
                    }
                });
        });
    }

    // #endregion

    // #region Métodos del servicio relacionados con la lógica de la aplicación

    /**
     * Crea un turno no informado.
     * @param opcion La opción seleccionada por el usuario.
     * @returns El turno no informado creado.
     */
    crearTurnoNoInformado(opcion: string): TurnoNoInformado {
        let desplazamientoZona: number = moment().utcOffset();
        const turnoNoInformado: TurnoNoInformado = {
            id: 0,
            employees_Id: 0,
            tipo: opcion,
            desplazamientoZona: desplazamientoZona,
            fecha: new Date().toISOString(),
            informadoPorEmail: false
        };
        
        return turnoNoInformado;
    }

    /**
     * Obtiene el turno activo.
     */
    hayTurnoActivo(): boolean {
        return this.turnoActivo != null;
    }

    /**
     * Comprueba si hay turnos caducados.
     */
    hayTurnosCaducados(): boolean {
        return this.turnosCaducados.length > 0;
    }

    // #endregion
}
